import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const NotFoundView = loadView('NotFoundView');

const notFoundRoute = {
  path: ROUTE.PATH.NOT_FOUND,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: Object.values(PRESCREENING.APPROVAL_KEY),
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.NOT_FOUND,
      component: NotFoundView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: Object.values(PRESCREENING.APPROVAL_KEY),
      },
    },
    {
      path: '*',
      redirect: ROUTE.PATH.NOT_FOUND,
    },
  ],
};

export default notFoundRoute;
